import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import lang from '../../../lib/language';
import { ENROLL_AUTH_REQUEST_TYPE } from '../../../lib/models/enroll-requests';
import { enrollAuth } from '../../../lib/store/auth';
import { useInterval } from '../../../lib/util/hooks/TimeoutHooks';
import { NullableNumber } from '../../../lib/util/types';

import { PhoneAutocompleteValue } from '../../../components/PhoneAutocomplete/PhoneAutocomplete.types';
import Button from '../../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../../shared_components/Button/Button.types';

const CounterStart = 59;

type Props = {
    phoneNumber: PhoneAutocompleteValue
    userId: NullableNumber
    setIsSendAgain: (isSendAgain: boolean) => void,
}

const Counter = ({ phoneNumber, userId, setIsSendAgain }:Props) => {
  const [isRunning, setIsRunning] = useState(true);
  const [counter, setCounter] = useState<number>(CounterStart);
  const dispatch = useDispatch();

  useInterval(() => {
    setCounter(counter - 1);
  }, isRunning ? 1000 : null);

  useEffect(() => {
    if (counter === 0) {
      setIsRunning(false);
    }
  }, [counter]);
  if (counter === 0) {
    return (
      <Button
        id="sendCodeAgain"
        ariaLabel="send code again"
        variant={ButtonTypesEnum.Link}
        onClick={() => {
          setCounter(CounterStart);
          setIsSendAgain(true);
          dispatch(enrollAuth({
            requestType: ENROLL_AUTH_REQUEST_TYPE.SEND_PHONE_CODE,
            phoneCode: phoneNumber.code.split(' ')[0],
            phoneNumber: phoneNumber.phone,
            userId,
          }));
          setIsRunning(true);
        }}
      >
        {lang.webSendAgain()}
      </Button>
    );
  }

  return (
    <span className="text-accent">
      {`0:${(counter < 10) ? (`0${counter}`) : counter}`}
    </span>
  );
};

export default Counter;
